var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-pane-template',{attrs:{"title":"代理店管理"}},[_c('agency-register-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }